import { Stack } from '@mui/material'

import {
  MultipleChoiceAnswerWithRelated,
  PromptWithRelated
} from '../../models/inspections'
import { AnswerTechnicianNotes } from './AnswerTechnicianNotes'
import { AnswerToActionSelection } from './AnswerToActionSelection'
import { UploadPhotoForAnswer } from './UploadPhotoForAnswer'

export const AnswerRelatedChoice = ({
  answer,
  prompt,
  isSelected,
  setIsSubmitting
}: {
  answer: MultipleChoiceAnswerWithRelated
  prompt: PromptWithRelated
  isSelected: boolean
  setIsSubmitting: (isSubmitting: boolean) => void
}) => {
  return (
    <>
      {' '}
      {isSelected ? (
        <Stack ml={4}>
          <AnswerToActionSelection answer={answer} />
          <AnswerTechnicianNotes
            prompt={prompt}
            answer={answer}
            setIsSubmitting={setIsSubmitting}
          />
          <UploadPhotoForAnswer answer={answer} prompt={prompt} />
        </Stack>
      ) : (
        <></>
      )}
    </>
  )
}
